import React, { Component } from 'react'
import { Link } from 'react-router'
import chunk from 'lodash/chunk'
import Container from 'muicss/lib/react/container'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'
import IcoAdd from 'react-icons/lib/io/plus-circled'
import IcoAdded from 'react-icons/lib/io/checkmark-circled'
import ItemModal from './ItemModal.jsx'
import util from '../util'
import _ from 'lodash'

const ItemList = ({ data, basePath, itemId, query, withoutCarriage, shouldSubtractCarriage, enableScroll }) => {
  const priceCaption = util.priceCaption(withoutCarriage)
  const cals = data.map(x => {
    const selectsOrderId = null
    // const selectsOrderId = x.selects_order_id ?
    //       <i className="item-lists__price">{x.selects_order_id}</i> : null
    return (
      <Col md="3" xs="6" key={x.id}>
          <div className="item-lists__card">
              <Link to={`${basePath}/items/${x.id}`} query={query}>
                  <div className="item-lists__image-container">
                      <img src={x.images[0]} alt="" />
                  </div>
                  <div className="item-lists__info">
                      <h4 className="item-lists__title">{x.name}</h4>
                      <p className="item-lists__description">{x.catch_copy}</p>
                  </div>
              </Link>
              <div className="item-lists__meta">
                  <i className="item-lists__price">{/* &yen;{util.displayPrice(x.price, shouldSubtractCarriage)}<span>{priceCaption}</span> */}</i>
                  {/* <span className="item-lists__action"><a><IcoAdd /></a><a><IcoAdded className="active" /></a></span> */}
                  {selectsOrderId}
              </div>
          </div>
      </Col>
    )}
                       )

  const item = _.find(data, {id: itemId});
  return (
    <div>
        <Container className="item-lists">
            <Row>
                {cals}
            </Row>
        </Container>
        <ItemModal item={item} back={basePath} query={query} withoutCarriage={withoutCarriage} shouldSubtractCarriage={shouldSubtractCarriage} enableScroll={enableScroll} />
    </div>
  )
}

export default ItemList



// WEBPACK FOOTER //
// ./src/components/ItemList.jsx